import { drawerClasses, type Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const ModalStyle: StyleExtend<Theme> = {
  [`.${drawerClasses.paper}`]: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    justifyContent: 'center',
    height: { xs: 'auto', sm: '100%' },
  },
};

export const ModalMainWrapperStyle: StyleExtend<Theme> = {
  overflow: { xs: 'hidden', sm: 'auto' },
  width: '100%',
};

export const ModalInnerWrapperStyle: StyleExtend<Theme> = {
  position: 'relative',
  width: 'fit-content',
  maxWidth: '688px',
  display: 'grid',
  gridTemplateRows: 'auto 1fr',
  color: (theme) => theme.palette.customColors.gunMetal,
  borderRadius: { xs: '1rem 1rem 0 0', sm: '1rem' },
  backgroundColor: (theme) => theme.palette.customColors.white50,
  marginBlock: { xs: '0', sm: '5rem' },
  marginInline: 'auto',
  maxHeight: { xs: '100dvh', sm: 'unset' },
};

export const ModalHeaderStyle: StyleExtend<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  paddingBlock: '1rem',
  borderBottom: (theme) => `1px solid ${theme.palette.customColors.lightGray}`,
  paddingInline: '1.5rem',
};

export const ModalContentWrapperStyle: StyleExtend<Theme> = {
  overflow: { xs: 'auto', sm: 'unset' },
};

export const ModalFooterStyle: StyleExtend<Theme> = {
  ...ModalHeaderStyle,
  borderBottom: 'none',
  borderTop: (theme) => `1px solid ${theme.palette.customColors.cream}`,
};

export const ModalContentStyle: StyleExtend<Theme> = {
  display: 'flex',
  padding: '1.5rem',
  flexDirection: 'column',
  flexGrow: 1,
  minWidth: { xs: '100vw', sm: '40rem', md: '43rem' },
};

export const ModalCloseButtonStyle: StyleExtend<Theme> = {
  position: 'absolute',
  width: '1.5rem',
  height: '1.5rem',
};

export const ModalTitleStyle: StyleExtend<Theme> = {
  marginInline: 'auto',
  fontWeight: (theme) => theme.typography.specialInfo.fontWeight,
};
